// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__mt1c7","author":"Table_author__saAUF","authorImage":"Table_authorImage__2dLi6","unreadRow":"Table_unreadRow__2iqEe"};